import { TargetDeliveryTemplateAccessFunction, TargetDeliveryTemplateSection } from 'data/targetDeliveryTemplateAccessFunction/targetDeliveryTemplateAccessFunction.types';

export function getTargetTemplateValues(
  sectionName: string,
  targetTemplate: TargetDeliveryTemplateAccessFunction,
): any {
  if (!targetTemplate) {
    return null;
  }

  const templateSection = (targetTemplate.templateSections as TargetDeliveryTemplateSection[])
    .filter((section) => section.name === sectionName)[0];

  if (!templateSection) {
    return null;
  }

  return templateSection.options.reduce((previous, current) => {
    let { value } = current;
    if (value === 'true' || value === 'false') {
      value = value === 'true' || false;
    }

    return ({ ...previous, [current.key]: value });
  },
    {});
}
